import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { recipeIngredientService } from '../services/recipeIngredientsService';
import {FilterGroup, ItemsStorageService} from "./filtering/itemsStorageService";
import IngredientHandler from "../components/recipes/IngredientHandler";

interface FiltersListItemCheckboxProps {
    itemsStorageService: ItemsStorageService,
    filterData: FilterGroup,
}

const FiltersListItemSelect = ({}: FiltersListItemCheckboxProps) => {
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        recipeIngredientService.createSearchParams(searchParams, setSearchParams);
        recipeIngredientService.loadItems(searchParams);
        return () => {
            recipeIngredientService.deleteItem('', true);
        };
    }, []);
    return (
        <IngredientHandler selectWithTokensManager={recipeIngredientService} />
    );
};

export default FiltersListItemSelect;
